/* Webknop: rustig, een pil, één duidelijke primaire actie per scherm (docs/DESIGN.md §2,
   docs/ux/ontwerpsysteem.md). Hoogtes uit de merktokens: 36 (klein), 44, 52 (groot). */
.button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--b-control, 44px);
  padding: 0 var(--space-4);
  border: 0;
  border-radius: var(--radius-pill);
  background: var(--surface-panel);
  color: var(--text);
  box-shadow: inset 0 0 0 1.5px var(--border);
  font-size: var(--text-md);
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  touch-action: manipulation;
  transition:
    background-color var(--dur) var(--ease-out),
    transform var(--dur-fast) var(--ease-out);
}

.button:hover {
  background: var(--surface-hover);
}

.button:active {
  background: var(--surface-pressed);
  transform: scale(0.98);
}

.button:focus-visible {
  outline: 3px solid var(--focus-ring);
  outline-offset: 2px;
}

.icon {
  margin-inline-start: -4px;
}

.primary {
  background: var(--accent-fill);
  color: var(--on-accent-fill);
  box-shadow: var(--shadow-1);
}

.primary:hover {
  background: var(--accent-fill-hover);
}

.primary:active {
  background: var(--accent-fill-pressed);
}

.danger {
  color: var(--danger);
  box-shadow: inset 0 0 0 1.5px var(--danger);
}

.danger:hover {
  background: var(--danger-tint);
}

.ghost {
  background: transparent;
  box-shadow: none;
  color: var(--text-muted);
}

.ghost:hover {
  background: var(--surface-hover);
  color: var(--text);
}

/* Tekstlink: ziet eruit als een link, maar het tikvlak blijft 44 px hoog (DESIGN §2.5). */
.link {
  min-height: var(--touch-min);
  padding: var(--space-1) var(--space-1);
  border-radius: var(--radius-sm);
  background: transparent;
  box-shadow: none;
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.link:hover,
.link:active {
  background: transparent;
  transform: none;
}

/* Klein: zichtbaar 36 px, maar het tikdoel blijft 44 px (DESIGN §2.5): de ::before steekt 4 px
   boven en onder uit, en de marge houdt die ruimte vrij in de rij. */
.small {
  min-height: var(--b-control-small, 36px);
  margin-block: 4px;
  padding: 0 var(--b-space-16, 16px);
  font-size: var(--b-text-small);
}

.small::before {
  content: '';
  position: absolute;
  inset: -4px 0;
}

.large {
  min-height: var(--b-control-large, 52px);
  padding: 0 var(--b-space-32, 32px);
  font-size: var(--b-text-lead);
}

.iconOnly {
  /* Nooit smaller dan 44 px, ook niet in een volle flexrij op de telefoon (ronde 3). */
  flex: 0 0 auto;
  width: var(--touch-min);
  min-width: var(--touch-min);
  padding: 0;
}

.iconOnly .icon {
  margin: 0;
}

/* Een kleine pictogramknop blijft 44 x 44: geen verborgen tikdoel nodig. */
.iconOnly.small {
  width: var(--touch-min);
  min-height: var(--touch-min);
  margin-block: 0;
}

.iconOnly.small::before {
  content: none;
}

.block {
  display: flex;
  width: 100%;
}

.disabled {
  opacity: 0.5;
  cursor: default;
}

.disabled:active {
  transform: none;
}

.spinner {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid currentColor;
  border-inline-end-color: transparent;
  animation: spin 800ms linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 2400ms;
  }
}
